import { createContext, useContext } from 'react'

export const NinetailedEnabledContext = createContext<boolean>(false)

export const useIsNinetailedEnabled = () => {
  return useContext(NinetailedEnabledContext)
}
